module.exports = __webpack_public_path__ + "img/数据圆饼图.9165dcc5.png";